import { apiFetch } from '@nrdy-marketing-engine/api-fetch';
import { LineItemResponse } from '@nrdy-marketing-engine/cart/@types/cart-state';

const updateLineItem = (
  cartId: string,
  lineItemId: string,
  clientId: string,
  lineItemResponse: LineItemResponse,
  student
) =>
  apiFetch(
    `/v1/carts/${cartId}/line-items/${lineItemId}?entity_id=${clientId}&entity_type=client`,
    {
      method: 'PATCH',
      body: JSON.stringify({
        data: {
          attributes: {
            cart_id: cartId,
            created_at: lineItemResponse?.created_at,
            created_by: lineItemResponse?.created_by,
            error_codes: lineItemResponse?.error_codes,
            errors: lineItemResponse?.errors,
            external_id: lineItemResponse?.external_id,
            final_price_cents: lineItemResponse?.final_price_cents,
            id: lineItemResponse?.id,
            is_valid: lineItemResponse?.is_valid,
            original_price_cents: lineItemResponse?.original_price_cents || 0,
            price_cents: lineItemResponse?.price_cents || 0,
            promotions: lineItemResponse?.promotions || [],
            quote_id: lineItemResponse?.quote_id,
            student: {
              email: student?.email,
              name: student?.first_name,
              id: student?.uuid,
            },
            updated_at: lineItemResponse?.updated_at,
            updated_by: lineItemResponse?.updated_by,
          },
          type: 'line_items',
        },
      }),
    }
  );

export default updateLineItem;
